export const constant = {
    GET_TOPMENU_DATA: 'GET_TOPMENU_DATA',
}